import React from 'react';
import { PlusIcon } from '@heroicons/react/24/solid';

/** Single FAB — create a new trip. */
const FabTripsMenu = ({ onNewTrip }) => (
  <div className="fixed bottom-20 right-6 z-40">
    <button
      type="button"
      onClick={() => onNewTrip?.()}
      className="bg-gray-700 hover:bg-gray-800 text-white p-3 rounded-full shadow-lg transition-colors"
      aria-label="New trip"
    >
      <PlusIcon className="h-8 w-8" />
    </button>
  </div>
);

export default FabTripsMenu;
